<template>
  <com-header title="客户签收">
    <div class="sign_goods">
      <div class="total">共计 {{totalBuyCount}} 件商品</div>
      <div class="brand_list" v-for="(item,index) in detailData.orderGoodsMixBrandList" :key="index">
        <div class="brand_name">{{item.goodsBrandName}}</div>
        <div class="goods_list">
          <div class="goods" v-for="(v,i) in item.orderGoodsMixList" :key="i">
            <div class="img">
              <img v-lazy="v.mainPreviewImageFilePath" alt="">
            </div>
            <div class="itr">
              <p class="label no">{{v.goodsCategoryName}} {{v.goodsMixNo}}</p>
              <p>
                <span>{{v.attr1ContentName || ""}} </span>
                <span>{{v.attr2ContentName || ""}} </span>
                <span>{{v.attr3ContentName || ""}} </span>
                <span>{{v.attr4ContentName || ""}}</span>
              </p>
              <p v-if="v.mixGoodsLength && v.mixGoodsWidth && v.mixGoodsHeight">
                {{v.mixGoodsLength+'*'+v.mixGoodsWidth+'*'+v.mixGoodsHeight}}(mm)
              </p>
              <p>x {{v.buyCount}}</p>
            </div>
            <div class="ques" v-if="detailData.orderStatus!==4">
              <van-button native-type="button" @click="goQuestionType(v)">问题反馈</van-button>
            </div>
          </div>
        </div>
      </div>
      <div class="distribute_detail">
        <p>
          <span class="label">工单号：</span>
          <span>{{detailData.workOrderNo}}</span>
        </p>
        <p>
          <span class="label">服务师傅：</span>
          <span>{{detailData.waiterName}}</span>
        </p>
        <p>
          <span class="label">联系电话：</span>
          <span>{{detailData.waiterMobile}}</span>
        </p>
      </div>
      <div class="action">
        <van-button v-if="detailData.orderStatus==2" size="mini" type="warning" native-type="button" @click="signGoods">
          确认收货并完成安装
        </van-button>
      </div>

      <van-dialog class="mydialog" v-model="showApplets" title="您已确认收货，后续可通过小程序查询订单！" :show-confirm-button="false">
        <img :src="require('@/assets/img/qrCode2.png')" alt="">
        <div class="close" @click="showApplets = false">
          <van-icon name="close" />
        </div>
      </van-dialog>
    </div>
  </com-header>
</template>

<script>
import ComHeader from "./components/comHeader";
import {
  GetOrderSignReceivedInfo,
  SignReceivedWorkOrder,
} from "@/pages/page1/api-work/index";
import { Button, Dialog, Icon } from "vant";
export default {
  metaInfo: { title: "客户签收" },
  components: {
    ComHeader,
    [Dialog.Component.name]: Dialog.Component,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      detailData: {},
      showApplets: false,
    };
  },
  mounted() {
    localStorage.setItem("H5HOME", this.$route.fullPath);
    this.getWorkOrderDetail(this.$route.query.orderId);
  },
  methods: {
    getWorkOrderDetail(orderId) {
      GetOrderSignReceivedInfo({ orderId }).then((res) => {
        // console.log("获取工单详情", res);
        this.detailData = res.data[0];
      });
    },
    signGoods() {
      SignReceivedWorkOrder({ orderId: this.detailData.id }).then((res) => {
        // console.log("确认签收结果", res);
        this.showApplets = true;
        this.getWorkOrderDetail(this.$route.query.orderId);
      });
    },
    goQuestionType(v) {
      this.$router.push({
        path: "/questionType",
        query: { id: v.id },
      });
    },
  },
  computed: {
    totalBuyCount() {
      let val = 0;
      let arr = this.detailData.orderGoodsMixBrandList || [];
      arr.forEach((item) => {
        item.orderGoodsMixList.forEach((v) => {
          val += v.buyCount;
        });
      });
      return val;
    },
  },
};
</script>

<style lang="less" scoped>
.sign_goods {
  padding: 0 0.3rem 1.6rem;
  font-size: 14px;
  .total {
    font-size: 12px;
    padding: 0.44rem 0 0.14rem;
    margin-bottom: 0.06rem;
    text-align: right;
    border-bottom: 1px solid rgba(168, 168, 168, 0.4);
  }
  .brand_list {
    box-sizing: border-box;
    .brand_name {
      padding-top: 0.24rem;
      padding-bottom: 0.04rem;
    }
    .goods_list {
      .goods {
        margin-top: 0.26rem;
        padding-bottom: 0.26rem;
        border-bottom: 1px solid rgb(241, 241, 241);
        display: flex;
        .img {
          margin-top: 0.04rem;
          width: 1.4rem;
          height: 1.4rem;
          border: 1px solid rgba(168, 168, 168, 0.4);
          box-sizing: border-box;
        }
        .itr {
          width: calc(100% - 1.4rem - 1.32rem);
          padding-left: 0.4rem;
          box-sizing: border-box;
          font-size: 12px;
          color: #a8a8a8;
          line-height: 18px;
          .no {
            font-size: 14px;
          }
          .label {
            color: #333333;
          }
        }
        .ques {
          width: 1.32rem;
          height: 0.5rem;
          box-sizing: border-box;
          align-self: flex-end;
          .van-button {
            width: 100%;
            height: 100%;
            padding: 0;
            font-size: 12px;
            border: 1px solid #a8a8a8;
          }
        }
      }
    }
  }
  .distribute_detail {
    margin-top: 0.26rem;
    line-height: 24px;
    .label {
      display: inline-block;
      min-width: 1.6rem;
    }
  }
  .action {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 1rem;
    .van-button {
      width: 100%;
      height: 1rem;
      font-size: 16px;
      background: @themeColor;
      border-color: @themeColor;
    }
  }
  /deep/ .mydialog {
    .van-dialog__header {
      padding: 26px 30px 0;
    }
    .van-dialog__content {
      display: flex;
      justify-content: center;
      padding: 0.6rem 0;
      .close {
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
      }
      img {
        width: 4rem;
        height: 4rem;
      }
    }
  }
}
</style>